/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface StaleState
 */
export interface StaleState {
    /**
     * In case the table content is stale: The last changed time, in UTC ISO instant such as '2011-12-03T10:15:30Z'
     * @type {string}
     * @memberof StaleState
     */
    lastChangedTime?: string;
    /**
     * 
     * @type {Command}
     * @memberof StaleState
     */
    tableUpdatedCommand?: Command;
    /**
     * Whether the table content is being updated in the background
     * @type {boolean}
     * @memberof StaleState
     */
    stale: boolean;
}

/**
 * Check if a given object implements the StaleState interface.
 */
export function instanceOfStaleState(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stale" in value;

    return isInstance;
}

export function StaleStateFromJSON(json: any): StaleState {
    return StaleStateFromJSONTyped(json, false);
}

export function StaleStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaleState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastChangedTime': !exists(json, 'lastChangedTime') ? undefined : json['lastChangedTime'],
        'tableUpdatedCommand': !exists(json, 'tableUpdatedCommand') ? undefined : CommandFromJSON(json['tableUpdatedCommand']),
        'stale': json['stale'],
    };
}

export function StaleStateToJSON(value?: StaleState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lastChangedTime': value.lastChangedTime,
        'tableUpdatedCommand': CommandToJSON(value.tableUpdatedCommand),
        'stale': value.stale,
    };
}

